<template>
    <div class="refund__body px-4 py-4">
        <!-- Scope cards -->
        <template v-if="subStep === SCOPE_SUBSTEP.CARDS">
            <label class="mb-3">Select refund scope</label>

            <div class="d-flex">
                <div class="refund__scope-card mr-3"
                    :class="{ 'refund__scope-card--selected': isSelected(REFUND_SCOPE.ALL_PAYMENTS) && canRefundAllPayments, 'refund__scope-card--disabled': !canRefundAllPayments }"
                    @click="canRefundAllPayments && $emit('input', REFUND_SCOPE.ALL_PAYMENTS)">
                    <i class="fas fa-bars mb-2 fs-large"
                        :class="isSelected(REFUND_SCOPE.ALL_PAYMENTS) ? 'refund__selected-color' : 'dark'"></i>
                    <strong class="font-weight-600"
                        :class="{ 'refund__selected-color': isSelected(REFUND_SCOPE.ALL_PAYMENTS) }">All
                        payments</strong>
                    <span class="fs-small dark mt-1">Refund the full transaction amount</span>
                </div>

                <div class="refund__scope-card" :class="{
                    'refund__scope-card--selected': isSelected(REFUND_SCOPE.SELECT_PAYMENT),
                    'refund__scope-card--disabled': singlePayment,
                }" v-tooltip="singlePayment ? 'This transaction only has one payment.' : ''"
                    @click="!singlePayment && $emit('input', REFUND_SCOPE.SELECT_PAYMENT)">
                    <i class="fas fa-list-ul mb-2 fs-large"
                        :class="isSelected(REFUND_SCOPE.SELECT_PAYMENT) ? 'refund__selected-color' : 'dark'"></i>
                    <strong class="font-weight-600"
                        :class="{ 'refund__selected-color': isSelected(REFUND_SCOPE.SELECT_PAYMENT) }">Select
                        payment</strong>
                    <span class="fs-small dark mt-1">Choose a specific payment to refund</span>
                </div>
            </div>
        </template>

        <!-- Payment picker -->
        <template v-else>
            <label class="mb-3">Select which payment to refund.</label>

            <payment-row v-for="(payment, index) in refundablePayments" :key="payment.id" class="mb-2"
                :payment="payment" :reservation="reservation" :index="index" :selectable="true"
                :selected="selectedPaymentId === payment.id" @select="$emit('select-payment', payment.id)" />
        </template>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import PaymentRow from '@/tools/modal/ReservationRefundTransaction/PaymentRow'
import { REFUND_SCOPE, SCOPE_SUBSTEP } from '@/utils/refundHelpers'

export default {
    name: 'RefundStep1Scope',
    mixins: [reservationsMixin],
    components: { PaymentRow },
    props: {
        value: {
            type: String,
            default: null,
        },
        subStep: {
            type: String,
            default: SCOPE_SUBSTEP.CARDS,
        },
        payments: {
            type: Array,
            default: () => [],
        },
        selectedPaymentId: {
            type: Number,
            default: null,
        },
        reservation: {
            type: Object,
            default: null,
        },
    },
    data() {
        return { REFUND_SCOPE, SCOPE_SUBSTEP }
    },
    computed: {
        canRefundAllPayments() {
            return this.payments.every(p => p.canBeRefunded);
        },
        singlePayment() {
            return this.payments.length === 1;
        },
        refundablePayments() {
            return this.payments.filter(p => p.canBeRefunded);
        },
    },
    watch: {
        payments: {
            immediate: true,
            handler() {
                this.ensureValidScope();
            },
        },
    },
    methods: {
        isSelected(scope) {
            return this.value === scope
        },
        ensureValidScope() {
            if (!this.payments.length) return;

            if (this.value === REFUND_SCOPE.ALL_PAYMENTS && !this.canRefundAllPayments) {
                this.$emit('input', REFUND_SCOPE.SELECT_PAYMENT);
            } else if (this.value === null) {
                this.$emit('input', this.canRefundAllPayments ? REFUND_SCOPE.ALL_PAYMENTS : REFUND_SCOPE.SELECT_PAYMENT);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables.scss';

$transition-speed: 0.15s;

.refund__selected-color {
    color: $color-1 !important;
}

.refund__body {
    min-height: 11.25rem;
}

.refund__scope-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.5rem 1rem;
    border: 1px solid $light;
    border-radius: 0.375rem;
    cursor: pointer;
    background: $lightest;
    transition: border-color $transition-speed, background $transition-speed;

    &--selected {
        border-color: $color-1;
        background: rgba($color-1, 0.06);
    }

    &--disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}
</style>



// WEBPACK FOOTER //
// Step1Scope.vue?a09133bc